import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { ExportTable } from '../../../../store/action/export/Export';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import UsePaymentReceived from './hooks/usePaymentReceived';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilterPage,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import advanceFilterIcon from '../../../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../../helper';
import Pagination from '../../../../component/pagination';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import { hasPermission } from '../../../../utils/controller';
import Button from '../../../../component/ui/Button';
import DataNotFound from '../../../components/dataNotFound';
import { Plus } from 'lucide-react';

const PaymentReceived = () => {
	const {
		user,
		paymentReceivedList,
		paymentReceievedParams,
		onRowClick,
		isLoading,
		bulkAction,
		navigate,
		suburl,
		setBulkAction,
		deselectRows,
		FilterDatalist,
		dispatch,
		headerDropDown,
		setHeaderDropDown,
		isAdvanceFilterApplied,
		setIsAdvanceFilterOpen,
		sortDataList,
		sortDirection,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		isAdvanceFilterOpen,
		selectedInputs,
		handleDeselectAll,
		handlePageChange,
		isLoader,
		handlePrintAndDownloadPdf,
		setPaymentRecievedParams,
	} = UsePaymentReceived();
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const exportTableData = (param) => {
		ExportTable(param);
	};

	const paymentsReceivedTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DATE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PR#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_receive_number' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PR#
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.payment_receive_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CUSTOMER NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CUSTOMER NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.customer_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PAYMENT MODE',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PAYMENT MODE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.payment_mode]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,

			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'received_payment_amount' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
									justifyContent: 'end',
								}}
							>
								AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.received_payment_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'UNUSED AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,

			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'excess_payment_amount' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
									justifyContent: 'end',
								}}
							>
								UNUSED AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.excess_payment_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					disabled: !hasPermission('sales.payments_received.create', user?.role?.role_permissions),
					buttonName: 'Create New Payment Received',
					handler: () => navigate(`/user/${suburl}/payments-received-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						disabled: !hasPermission(
							'sales.payments_received.download_print_pdf',
							user?.role?.role_permissions,
						),
						button: 'Print',
						loader: isLoader,
						handler: () => {
							handlePrintAndDownloadPdf('', 'print', true);
						},
					},
					{
						id: 2,
						disabled: true,
						className: 'btn-gray',
						button: 'Delete',
						handler: () => {},
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Cash Payments')}
								>
									Cash Payments
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Online Payments')}
								>
									Online Payments
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Customer Name')}
								>
									Customer Name
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Payment Type')}
								>
									Payment Type
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Payments Received');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<Button
							type="button"
							button="Advanced Filters"
							className="mt-0 px-4 btn-primary"
							onClick={() => setIsAdvanceFilterOpen(true)}
							icon={advanceFilterIcon}
						/>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img
								src={sortbydot}
								alt=""
							/>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser"
							style={{ minWidth: '240px' }}
						>
							<li style={{ cursor: 'pointer' }}>
								<a
									className="dropdown-item"
									style={{
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px',
										fontWeight: 'bold',
										justifyContent: 'space-between',
									}}
								>
									Sort By
								</a>
							</li>

							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
								>
									Date
									<span>{sortIconMap[sortDirection?.date]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() =>
										sortDataList({ order_by: 'asc', sort_by: 'payment_receive_number' })
									}
								>
									Payment#
									<span>{sortIconMap[sortDirection?.payment_receive_number]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'notes' })}
								>
									Reference #<span>{sortIconMap[sortDirection?.notes]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
								>
									Customer Name
									<span>{sortIconMap[sortDirection?.customer_name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
								>
									Payment Mode
									<span>{sortIconMap[sortDirection?.payment_mode]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() =>
										sortDataList({ order_by: 'asc', sort_by: 'received_payment_amount' })
									}
								>
									Amount
									<span>{sortIconMap[sortDirection?.received_payment_amount]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() =>
										sortDataList({ order_by: 'asc', sort_by: 'excess_payment_amount' })
									}
								>
									Unused Amount
									<span>{sortIconMap[sortDirection?.excess_payment_amount]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'created_at' })}
								>
									Created Timed
									<span>{sortIconMap[sortDirection?.created_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
								>
									Last Modified Time
									<span>{sortIconMap[sortDirection?.updated_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className={`dropdown-item ${!hasPermission('sales.payments_received.import', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => {}}
								>
									Import Payments
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className={`dropdown-item ${!hasPermission('sales.payments_received.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => {
										exportTableData('payments_receive');
									}}
								>
									Export Payments
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'preferences' })}
								>
									Preferences
									<span>{sortIconMap[sortDirection?.preference]}</span>
								</a>
							</li>

							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'id' })}
								>
									Refresh
									<span>{sortIconMap[sortDirection?.id]}</span>
								</a>
							</li>
						</ul>
					</div>
				}
			/>
			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Payments Received');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon">
									<Plus width={15} />
								</span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : paymentReceivedList.data.length > 0 ? (
				<Table
					row={paymentReceivedList.data}
					coloum={paymentsReceivedTableColumn}
					className="productTable"
					onRowClick={onRowClick}
					bulkAction={bulkAction}
					action={setBulkAction}
					style={
						isAdvanceFilterApplied
							? { height: 'calc(100vh - 185px)' }
							: { height: 'calc(100vh - 148px)' }
					}
					onDeselectAll={handleDeselectAll}
				/>
			) : (
				<DataNotFound
					title={'Track all your payments with ease!'}
					subtitle={'Keep every payment organized and up to date.'}
					descriptionTitle={'Keep your payment history organized to simplify '}
					descriptionSubTitle={'reconciliation, cash flow tracking, and financial '}
					descriptionContent={'reporting.'}
					buttonText={'Create New Payment Received'}
					disabled={!hasPermission('sales.payments_received.create', user?.role?.role_permissions)}
					onClick={() => navigate(`/user/${suburl}/payments-received-create`)}
				/>
			)}
			{paymentReceivedList.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : paymentReceievedParams.page}
					totalPages={
						isAdvanceFilterApplied ? advanceFilterTotalPages : paymentReceivedList.totalPages
					}
					onChangePage={handlePageChange}
					pageSize={
						isAdvanceFilterApplied ? advanceFilterPageSize : paymentReceievedParams.page_size
					}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setPaymentRecievedParams((prev) => ({
								...prev,
								page_size: value,
							}));
						}
					}}
				/>
			)}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.payments_received}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};
export default PaymentReceived;
